/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/activities_notes_junction-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/activities_notes_junction-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/activities_notes_junction-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-activities_notes_junction-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/activities_notes_junction.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-29T23:22:39.679Z
 * Source config: config/entities/activities_notes_junction-entity-config.ts
 * Public fields: 17/17 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const ActivitiesNotesJunctionSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  activity_id: Type.String({ format: "uuid" }), // activity_id field
  note_id: Type.String({ format: "uuid" }), // note_id field
  trig_note_title: Type.Union([Type.String(), Type.Null()]), // trig_note_title field - trigger-populated denormalized field
  trig_note_type: Type.Union([Type.String(), Type.Null()]), // trig_note_type field - trigger-populated denormalized field
  trig_note_is_internal: Type.Union([Type.Boolean(), Type.Null()]), // trig_note_is_internal field - trigger-populated denormalized field
  trig_note_created_by: Type.Union([Type.String(), Type.Null()]), // trig_note_created_by field - trigger-populated denormalized field
  trig_note_content: Type.Union([Type.String(), Type.Null()]), // trig_note_content field - trigger-populated denormalized field
  trig_activity_name: Type.Union([Type.String(), Type.Null()]), // trig_activity_name field - trigger-populated denormalized field
  trig_activity_status_name: Type.Union([Type.String(), Type.Null()]), // trig_activity_status_name field - trigger-populated denormalized field
  trig_activity_type_name: Type.Union([Type.String(), Type.Null()]), // trig_activity_type_name field - trigger-populated denormalized field
  trig_activity_scheduled_date: Type.Union([Type.String(), Type.Null()]), // trig_activity_scheduled_date field - trigger-populated denormalized field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field - auto-managed timestamp
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field - auto-managed timestamp
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  trig_note_assigned_to: Type.Union([Type.String(), Type.Null()]), // trig_note_assigned_to field - trigger-populated denormalized field
  trig_activity_assigned_users: Type.Union([Type.String(), Type.Null()]), // trig_activity_assigned_users field - trigger-populated denormalized field
});

export const CreateActivitiesNotesJunctionSchema = Type.Object({
  activity_id: Type.String({ format: "uuid" }), // activity_id field
  note_id: Type.String({ format: "uuid" }), // note_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

export const UpdateActivitiesNotesJunctionSchema = Type.Object({
  activity_id: Type.String({ format: "uuid" }), // activity_id field
  note_id: Type.String({ format: "uuid" }), // note_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type ActivitiesNotesJunctionRow = Static<typeof ActivitiesNotesJunctionSchema>;
export type ActivitiesNotesJunctionInsert = Static<typeof CreateActivitiesNotesJunctionSchema>;
export type ActivitiesNotesJunctionUpdate = Static<typeof UpdateActivitiesNotesJunctionSchema>;

// Legacy type aliases for backward compatibility
export type ActivitiesNotesJunction = ActivitiesNotesJunctionRow;
export type CreateActivitiesNotesJunction = ActivitiesNotesJunctionInsert;
export type UpdateActivitiesNotesJunction = Static<typeof UpdateActivitiesNotesJunctionSchema>;

// Field configuration metadata
export const ActivitiesNotesJunctionFieldConfig = {
  filterable: ['id', 'activity_id', 'note_id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['activity_id', 'note_id'] as const,
  readonly: ['id', 'trig_note_title', 'trig_note_type', 'trig_note_is_internal', 'trig_note_created_by', 'trig_note_content', 'trig_activity_name', 'trig_activity_status_name', 'trig_activity_type_name', 'trig_activity_scheduled_date', 'created_at', 'updated_at', 'trig_note_assigned_to', 'trig_activity_assigned_users'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface ActivitiesNotesJunctionQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface ActivitiesNotesJunctionResponse {
  data: ActivitiesNotesJunction[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleActivitiesNotesJunctionResponse {
  data: ActivitiesNotesJunction | null;
  error: Error | null;
}
